import React from "react";
import transakSDK from '@transak/transak-sdk'

let transak = new transakSDK({
    apiKey: '0cc78253-24e7-4203-add5-525333bcec2c',  // Your API Key (Required)
    environment: 'STAGING', // STAGING/PRODUCTION (Required)
    defaultCryptoCurrency: 'MATIC',
    walletAddress: '', // Your customer wallet address
    themeColor: '000000', // App theme color in hex
    email: '', // Your customer email address (Optional)
    redirectURL: '',
    hostURL: window.location.origin, // Required field
    widgetHeight: '700px',
    widgetWidth: '450px',
    cryptoCurrencyCode: 'MATIC',
    hideMenu: true,
    // defaultFiatAmount: 26,
    // fiatCurrency: 'EUR',
    defaultCryptoAmount: 27

});

// To get all the events
transak.on(transak.ALL_EVENTS, (data) => {
    console.log(data)
});

// This will trigger when the user closed the widget
transak.on(transak.EVENTS.TRANSAK_WIDGET_CLOSE, (orderData) => {
    transak.close();
});

// This will trigger when the user marks payment is made.
transak.on(transak.EVENTS.TRANSAK_ORDER_SUCCESSFUL, (orderData) => {
    console.log(orderData);
    transak.close();
});
const TransakComponet = () => {
    transak.init();
}
export default TransakComponet;
